import React from 'react';
import serviceUrls from '../../../../constants/serviceUrls';
import * as apiCaller from '../../../../helpers/apiCaller'
import uiHelpers from '../../../../helpers/uiHelpers';
import { FlatForm, mandatoryValidator, positiveWholeNumberValidator, preConditionToValidate, txtMandatoryValidator } from '../../../../helpers/FormHelper';
import { Pen } from '../../../../components/tools/Icons';
import { isStringNullOrEmpty } from '../../../../helpers/validators';
import { AsteriskRed } from '../../../../components/tools/Others';


class MeterAdminEdit  extends React.Component {

    editMeterForm;
    constructor(props) {
        super(props);
        this.state = {
            confirming:false
            , submitting:false
            , succeeded:false
        };

        this.editMeterForm = new FlatForm("editMeterForm", this);
        this.editMeterForm.initialise([
            "id",
            "comments",
            "manufacturerAndModelChanged",
            "originalManufacturerAndModel",
            "newManufacturerAndModel",
            "otherManufacturerAndModelTextChanged",
            "originalOtherManufacturerAndModelText",
            "newOtherManufacturerAndModelText",
            "patternApprovalNumberChanged",
            "originalPatternApprovalNumber",
            "newPatternApprovalNumber",
            "meterSizeChanged",
            "originalMeterSize",
            "newMeterSize",
            "meterSerialNoChanged",
            "originalMeterSerialNo",
            "newMeterSerialNo",
            "lidSerialNumberChanged",
            "originalLidSerialNumber",
            "newLidSerialNumber",
            "global"
        ]).setPostChangeActions({
            newManufacturerAndModel:(val,vals,form)=>{
                form.vals({newOtherManufacturerAndModelText:'', otherManufacturerAndModelTextChanged : this.isAnyNonPatternApproved()?true:null}, false);
                form.errs({newOtherManufacturerAndModelText:null});
            }
        }).setValueChangedValidators({
            newMeterSize:[preConditionToValidate((val, vals)=>vals.meterSizeChanged===true,positiveWholeNumberValidator('Please enter a valid meter size (between 10 and 9999, no decimals values allowed)'))]
        }).defineAction("submit",this.submit,{
            comments:[txtMandatoryValidator("This is required")],
            newManufacturerAndModel:[preConditionToValidate((val,vals)=>vals.manufacturerAndModelChanged===true,mandatoryValidator("This is required"))],
            newOtherManufacturerAndModelText:[preConditionToValidate((val,vals)=>(vals.otherManufacturerAndModelTextChanged===true && vals.newManufacturerAndModel && vals.newManufacturerAndModel.key=="Non-Pattern Approved Meter"),txtMandatoryValidator("This is required"))],
            newMeterSize:[preConditionToValidate((val, vals)=>vals.meterSizeChanged===true,txtMandatoryValidator("This is required")),positiveWholeNumberValidator('Please enter a valid meter size (between 10 and 9999, no decimals values allowed)')],
            newMeterSerialNo:[preConditionToValidate((val, vals)=>vals.meterSerialNoChanged===true,txtMandatoryValidator("This is required"))],
            newLidSerialNumber:[preConditionToValidate((val, vals)=>vals.lidSerialNumberChanged===true,txtMandatoryValidator("This is required"))],
            global:[(val)=>{

                const fieldsToCheck = [
                    "manufacturerAndModelChanged",
                    "otherManufacturerAndModelTextChanged",
                    "patternApprovalNumberChanged",
                    "meterSizeChanged",
                    "meterSerialNoChanged",
                    "lidSerialNumberChanged"
                ];

                const someChanged = fieldsToCheck.some(
                    f => this.editMeterForm.vals()[f] === true
                );

                if(someChanged) return null;
                return "No changes were detected. Please modify at least one field before submitting."
            }]
        })
    }

    async componentDidMount() {
        await this.reset();
    }

    submit = () => {
        this.editMeterForm.disableForm(()=>{
            this.setState({confirming:true})
        });
    }

    onCancelClick = () => {
        this.editMeterForm.enableForm(()=>{
            this.setState({confirming:false})
        });
    }

    onConfirmClick = async () => {
        uiHelpers.showProgressOnTop('Saving your changes...');
        this.setState({submitting:true})
        await apiCaller.post(serviceUrls.meter.adminEditMeterSave,{form:this.editMeterForm.vals()}).then(async ()=>{
            await this.props.refresh(); 
            this.setState({succeeded:true, submitting:false});   
            uiHelpers.hideProgressOnTop();
        })
        
    }

    isAnyNonPatternApproved(){
        const form = this.editMeterForm;
        return (
                (form.val('originalManufacturerAndModel') && form.val('originalManufacturerAndModel').key=='Non-Pattern Approved Meter' )
                ||
                (form.val('newManufacturerAndModel') && form.val('newManufacturerAndModel').key=='Non-Pattern Approved Meter' )
            )
    }

    renderInfoCorrectionRow = (lable, editing, originalFieldNotChanged, originalFieldChanged, newField, renderNewField = true, fieldWidth = 8) =>{
        return <div class="row mb-3 ">
                    <div class="col-md-4 py-2">{lable}</div>
                    <div className={"col-md-" + fieldWidth}>
                        <div class="card bg-light mb-3">
                            <div class="card-body p-2 text-wrap">
                                {editing ? originalFieldChanged : originalFieldNotChanged}
                            </div>
                        </div>
                        {editing && renderNewField && newField}
                    </div>
                </div>
    }

    reset = async ()=>{
        this.editMeterForm.disableForm();
        await apiCaller.post(serviceUrls.meter.adminEditMeter,{id:this.props.meter.id})
        .then((data, callback) => {
            this.editMeterForm.vals(data.form.fields, false);
            this.editMeterForm.setOptions(data.form.optionsForFields, false);
            this.editMeterForm.enableForm();
        })
    }

    onEditManufacturerClicked = () => {
        const form = this.editMeterForm;
        form.vals({
            manufacturerAndModelChanged:true,
            otherManufacturerAndModelTextChanged: this.isAnyNonPatternApproved()?true:null
        })
    }

    onCancelEditManufacturerClicked = () => {
        const form = this.editMeterForm;
        form.vals({
            manufacturerAndModelChanged:null,
            newManufacturerAndModel:null,
            otherManufacturerAndModelTextChanged:null,
            newOtherManufacturerAndModelText:""
        }, false);
        form.errs({
            newManufacturerAndModel:"",
            newOtherManufacturerAndModelText:""
        }, false);
        this.setState({editingManufacturer:false})
    }

    onEditPatternApprovedNoClicked = () => {
        const form = this.editMeterForm;
        form.vals({patternApprovalNumberChanged:true})
    }

    onCancelPatternApprovedNoClicked = () => {
        const form = this.editMeterForm;
        form.errs({newPatternApprovalNumber:""}, false);
        form.vals({newPatternApprovalNumber:"", patternApprovalNumberChanged:null});
    }

    onEditMeterSizeClicked = () => {
        const form = this.editMeterForm;
        form.vals({meterSizeChanged:true})
    }

    onCancelMeterSizeClicked = () => {
        const form = this.editMeterForm;
        form.errs({newMeterSize:""}, false);
        form.vals({newMeterSize:"", meterSizeChanged:null});
    }

    onEditMeterSerialNoClicked = () => {
        const form = this.editMeterForm;
        form.vals({meterSerialNoChanged:true})
    }

    onCancelMeterSerialNoClicked = () => {
        const form = this.editMeterForm;
        form.errs({newMeterSerialNo:""}, false);
        form.vals({newMeterSerialNo:"",meterSerialNoChanged:null});
    }

    onEditLidSerialNoClicked = () => {
        const form = this.editMeterForm;
        form.vals({lidSerialNumberChanged:true})
    }

    onCancelLidSerialNoClicked = () => {
        const form = this.editMeterForm;
        form.errs({newLidSerialNumber:""}, false);
        form.vals({newLidSerialNumber:"", lidSerialNumberChanged:null});
    }

    convertToItalicBlankTextIfEmptyAfterTrim = (value) =>{
        if(isStringNullOrEmpty(value)) return <i className='text-muted fs-90'>blank</i>;
        return value;
    }

    renderEditBtn = (event) => {
        return <button className='btn btn-outline-primary btn-sm me-3' disabled={this.editMeterForm.isFormDisabled()} onClick={event}><Pen/></button>
    }

    renderCancelEditBtn = (event) => {
        return <button className='btn btn-sm btn-primary' disabled={this.editMeterForm.isFormDisabled()} onClick={event}>Cancel Edit</button>
    }

    render() {

        if(!this.state.succeeded && this.props.meter.status!='ACTIVE') return <div className='alert alert-danger mt-4'>This meter cannot be edited under the current status.  Only <b>Active</b> meter can be edited by this function.</div>;

        const form = this.editMeterForm;
        const meter = this.props.meter;
        return <>

            <div className='alert alert-primary'>
                You are attempting to edit this meter. Only a limited number of fields can be edited using this function. If you need to modify other fields, please contact the system administrator.
            </div>

            {form.renderTextBoxRow("comments",<>Comments <AsteriskRed/></>, { rowClasses: 'mb-3' })}

            {this.renderInfoCorrectionRow(
                'Meter Manufacturer Model', form.val("manufacturerAndModelChanged"),
                <>
                    {this.renderEditBtn(this.onEditManufacturerClicked)}
                    {form.val("originalManufacturerAndModel") && form.val("originalManufacturerAndModel").name}
                </>
                ,
                <>
                    <span className='text-decoration-line-through me-3'>{form.val("originalManufacturerAndModel") && form.val("originalManufacturerAndModel").name}</span>
                    {this.renderCancelEditBtn(this.onCancelEditManufacturerClicked)}
                </> 
                ,
                <>
                    {form.renderDropDown('newManufacturerAndModel',(o)=>o.id, (o)=>o.name) }
                    <div className='text-warning'>Please notify the DAS team as the Meter Manufacturer Model Information also stored in <strong>DAS</strong>. Please also match the same information in <strong>WAS</strong>.</div>
                </>
            )}

            {
                this.isAnyNonPatternApproved()
                && <>
                {this.renderInfoCorrectionRow(
                    'Non-Pattern Approved Meter Details', form.val("otherManufacturerAndModelTextChanged")
                    ,
                    <>
                        {this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalOtherManufacturerAndModelText"))}
                    </>
                    ,
                    <>
                        <span className='text-decoration-line-through me-3'>{this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalOtherManufacturerAndModelText"))}</span>
                    </>
                    ,
                    form.renderTextBox('newOtherManufacturerAndModelText'),
                    (form.val('newManufacturerAndModel') && form.val('newManufacturerAndModel').key=='Non-Pattern Approved Meter' )
                )}
            </>}

            {this.renderInfoCorrectionRow(
                'Pattern Approval Number (if applicable)',form.val("patternApprovalNumberChanged")
                ,
                <>
                    {this.renderEditBtn(this.onEditPatternApprovedNoClicked)}
                    {this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalPatternApprovalNumber"))}
                </>
                ,
                <>
                    <span className='text-decoration-line-through me-3 text-muted'>{this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalPatternApprovalNumber"))}</span>
                    {this.renderCancelEditBtn(this.onCancelPatternApprovedNoClicked)}
                </> 
                ,
                form.renderTextBox("newPatternApprovalNumber")
            )}

            {this.renderInfoCorrectionRow(
                'Meter Size(mm)',form.val("meterSizeChanged")
                ,
                <>
                    {this.renderEditBtn(this.onEditMeterSizeClicked)}
                    {this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalMeterSize"))}
                </>
                ,
                <>
                    <span className='text-decoration-line-through me-3'>{this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalMeterSize"))}</span>
                    {this.renderCancelEditBtn(this.onCancelMeterSizeClicked)}
                </>
                ,
                form.renderTextBox("newMeterSize")
            )}

            {this.renderInfoCorrectionRow(
                'Meter Serial Number',form.val("meterSerialNoChanged")
                ,
                <>
                    {this.renderEditBtn(this.onEditMeterSerialNoClicked)}
                    {this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalMeterSerialNo"))}
                </>
                ,
                <>
                    <span className='text-decoration-line-through me-3'>{this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalMeterSerialNo"))}</span>
                    {this.renderCancelEditBtn(this.onCancelMeterSerialNoClicked)}
                </>
                ,
                form.renderTextBox("newMeterSerialNo")
            )}

            {meter.isLidExempted!==true && this.renderInfoCorrectionRow(
                'LID Serial number',form.val("lidSerialNumberChanged")
                ,
                <>
                    {this.renderEditBtn(this.onEditLidSerialNoClicked)}
                    {this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalLidSerialNumber"))}
                </>
                ,
                <>
                    <span className='text-decoration-line-through me-3'>{this.convertToItalicBlankTextIfEmptyAfterTrim(form.val("originalLidSerialNumber"))}</span>
                    {this.renderCancelEditBtn(this.onCancelLidSerialNoClicked)}
                </>
                ,
                form.renderTextBox("newLidSerialNumber")
            )}  

            {form.haveErrors() && form.err("global") != null && <div className='alert alert-danger'>
                {form.err("global")}
            </div>}

            {form.haveErrors() && form.err("global") == null && <div className='alert alert-danger'>
                Please complete the required information and resolve any errors that may display in order to proceed further.
            </div>}
            
            {!this.state.succeeded && <>{this.state.confirming ? <div className='card border-primary border-1 mb-3'>
                <div className='card-body bg-primary bg-opacity-10 text-center'>
                    <p className='text-primary'>
                        <b>Please confirm that you would like to proceed with this updated meter record.</b>
                    </p>
                    <div>
                        <button type="button" class="btn btn-secondary me-3" onClick={this.onCancelClick} disabled={this.state.submitting}>
                            Cancel
                        </button>
                        <button type="button" class="btn btn-primary" onClick={this.onConfirmClick} disabled={this.state.submitting} >
                            Confirm
                        </button>
                    </div>
                </div>
            </div> : <div class="row mb-3 ">
                    <div class="col-md-4 py-2"></div>
                    <div className={"col-md-8"}>
                        <button type="button" class="btn btn-primary" onClick={()=>form.runAction("submit")} >
                            Proceed
                        </button>
                    </div>
            </div>}</>}
            
            {this.state.succeeded && <div className='card border-success border-1 mb-3'>
                <div className='card-body bg-success bg-opacity-10 text-center text-success'>
                    <b>You change has been saved.</b>
                </div>
            </div>}

        </>
    }

}

export default MeterAdminEdit;